import React, { useEffect, useRef } from 'react';
import { MainLayout } from '../layouts';
import SignupHero from '../components/home/landing/SignupHero';
import analyticsService from '../services/analytics';
import { getAttribution } from '../utils/attribution';

/**
 * /register: the landing page's hero (the pitch and the free-trial form), full
 * width, so Join Now lands on the same form and the same look as the home page.
 * The form records the registration funnel itself; this page records the view.
 */
const RegisterPage: React.FC = () => {
  const tracked = useRef(false);
  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    try {
      analyticsService.trackRegistrationPageView({
        referrer: document.referrer || 'direct',
        timestamp: new Date().toISOString(),
        attribution: getAttribution(),
      });
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }, []);

  return (
    <MainLayout>
      <div className="ui-bleed">
        <SignupHero source="register" />
      </div>
    </MainLayout>
  );
};

export default RegisterPage;
